module.exports = __webpack_public_path__ + "img/person-search.77928690.svg";